import {Component} from '@angular/core';
import {SearchService} from "../_services/search.service";
import {SearchRequest} from "../_models/searchRequest";
import {AuthenticationService} from "../_services";
import {Individual} from "../_models/individual";
import {SearchHit} from "../_models/searchHit";

@Component({
    moduleId: module.id,
    templateUrl: 'search.component.html'
})

export class SearchComponent {

    model: SearchRequest = new SearchRequest();
    hits: Array<SearchHit> = [];
    initialized: boolean = false;
    loading = undefined;

    constructor(private searchService: SearchService,
                private authService: AuthenticationService) {
        this.initialized = false;
    }

    search() {
        this.loading = 'searching';
        this.searchService.search(this.model).then(data => {

            this.hits = [];

            for (let hit of data.hits) {
                this.hits.push(hit.source);
            }
            this.loading = undefined;
            this.initialized = true;
        }).catch( (error: Response) => {
            if (error.status === 401 || error.status === 403) {
                this.authService.logout('login', {queryParams: {returnUrl:'search'}});
            }
            this.loading = undefined;
            this.initialized = true;
        });
    }

    buildFirstNames(individual: Individual) {
        let givenNameCode = individual.givenNameCode;
        if (!givenNameCode || givenNameCode.length < 2) {
            return this.buildDefaultFirstNames(individual.firstNames)
        }
        const first = Number(givenNameCode[0]);
        const second = Number(givenNameCode[1]);

        if ((!first || first === 0) && (!second || second === 0)) {
            return this.buildDefaultFirstNames(individual.firstNames)
        }
        const result = [];
        let itr = 0;
        for (let firstName of individual.firstNames) {
            let nameParts = firstName.split(/[-]/);
            const subResult = [];
            for (let subFirstName of nameParts) {
                if (first === (itr + 1) || second === (itr + 1)) {
                    subResult.push(`<b>${subFirstName}</b>`)
                } else {
                    subResult.push(subFirstName)
                }
                itr++
            }
            result.push(`<div>${subResult.join('-')}</div>`)
        }
        return result.join(' ');
    }

    buildDefaultFirstNames(firstNames: string[]): string {
        const result = [];
        for (let i in firstNames) {
            result.push(`<div>${firstNames[i]}</div>`)
        }
        return result.join(' ');
    }
}


// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/search/search.component.ts